<template>
    <div class="web-advertising-container">
        <div class="web-adv-item left-web-adv">
            <div class="logo-box">
                <img src="https://cdn1.p2ipo.com/pc/commonDetail/shanhai-logo2x.png" alt="">
                <p class="shanhai">山海云仓</p>
                <p class="shanhai-e">SHANHAI</p>
            </div>
            <div class="info-box">
                <div class="txt1" title="“山海云仓”以中国海外产业园为依托，为中国中小企业解决国际贸易中仓储物流、商品展示、在线商城、远程管理、电子报关、海外促销等一站式云仓系统；与中信银行联合推出国际商务考察，让中国中小企业通过参观、考察、交流建立真实的国际贸易资源，分享国家“一带一路”战略的伟大成果">
                    “山海云仓”以中国海外产业园为依托，为中国中小企业解决国际贸易中仓储物流、
                    商品展示、在线商城、远程管理、电子报关、海外促销等一站式云仓系统；
                    与中信银行联合推出国际商务考察，让中国中小企业通过参观、......
                </div>
                <div class="web-url">
                    <a href="http://www.b2bscm.net" target="_blank">www.b2bscm.net</a>
                </div>
            </div>
        </div>
        <div class="web-adv-item right-web-adv">
            <div class="logo-box">
                <p class="logo-txt">湾潮</p>
                <p class="logo-txt-e">BAY TREND</p>
            </div>
            <div class="info-box">
                <div class="txt1">
                    湾潮——聚焦中国粤港澳大湾区“9+2”城市群，携手“一带一路”互联互通，融入全球开放型创新体系构建，
                    围绕科技产业高端价值链，共建共享大湾区优质生活圈。
                </div>
                <div class="web-url">
                    <a href="https://www.bigbays.cn" target="_blank">www.bigbays.cn</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'WebAdvertisingP',
    data() {
        return {}
    },
    methods: {
        
    }
}
</script>
<style lang="scss" scoped>
@import './WebAdvertisingComponentP.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/advertising/WebAdvertisingComponentP.vue